import script from "./ApixDriveDataTabInstruction.vue?vue&type=script&setup=true&lang=js"
export * from "./ApixDriveDataTabInstruction.vue?vue&type=script&setup=true&lang=js"

import "./ApixDriveDataTabInstruction.vue?vue&type=style&index=0&id=62437ccd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62437ccd"]])

export default __exports__